(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.GraphicalComponents;

    (function (GraphicalComponents, $, undefined) {
        /**
         * Actions to be used on buttons.
         * @memberOf Lfl.GraphicalComponents
         */
        Lfl.GraphicalComponents.Buttons;

        (function (Buttons, $, undefined) {
            /**
             *
             * @param {string} inputPath The path to the select input field.
             * @memberOf Lfl.GraphicalComponents.Buttons
             */
            Buttons.selectAllSelect2 = function (inputPath) {
                var $select = $(inputPath);
                var selected = [];
                $select.find("option").each(function (i, e) {
                    selected[selected.length] = $(e).attr("value");
                });
                $select.select2().val(selected).trigger("change");
            };

            /**
             * @param {string} inputPath The path to the select input field.
             * @param {array} values The values to select
             *
             * @memberOf Lfl.GraphicalComponents.Buttons
             */
            Buttons.selectSubsetFromSelect2 = function (inputPath, values) {
                var $select = $(inputPath);
                var possibleValues = [];

                $select.find("option").each(function (i, e) {
                    possibleValues[possibleValues.length] = $(e).attr("value");
                });

                // Sadly, JS reads the values from select as strings so intersection would not work unless we convert the
                // sent values to string as well
                var stringValues = [];

                _.each(values, function(value, key) {
                    stringValues[stringValues.length] = value.toString();
                });

                var selected = _.intersection(stringValues, possibleValues);

                $select.select2().val(selected).trigger("change");
            };

            Buttons.checkAllInForm = function (formName) {
                var $form = $("[name=" + formName + "]");
                // var $form = $(formName);
                var checkboxes = $form.find("input[type='checkbox']");

                for(var i=0, n=checkboxes.length;i<n;i++) {
                    $(checkboxes[i]).iCheck('check');
                }
                //TODO DEC-318 check all inputs
            };

            Buttons.checkInFormByAttribute = function (formName, attribute) {
                var $form = $("[name=" + formName + "]");
                var checkboxes = $form.find("input[type='checkbox']");

                for(var i=0, n=checkboxes.length;i<n;i++) {
                    if (checkboxes[i].getAttribute(attribute) == "true"){
                        $(checkboxes[i]).iCheck('check');
                    } else {
                        $(checkboxes[i]).iCheck('uncheck');
                    }
                }
            };

            Buttons.initDatatablePopoverButton = function (element, row) {
                const contentElement = row.querySelector('#' + element.id + '-content');

                initializePopoverButton(contentElement, element);
            };

            Buttons.initClassicPopoverButton = function (elementId) {
                const element = document.getElementById(elementId);
                const contentElement = document.getElementById(elementId + '-content');

                initializePopoverButton(contentElement, element);
            };

            function initializePopoverButton(contentElement, buttonElement) {
                const $content = $(contentElement);

                $(buttonElement).popover({
                    html: true,
                    content: function () {
                        return $content.html();
                    }
                })
            }
        }(GraphicalComponents.Buttons = GraphicalComponents.Buttons || {}, jQuery));
    }(Lfl.GraphicalComponents = Lfl.GraphicalComponents || {}, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
